// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2eHpy","clinicsSelect":"TableHeading_clinicsSelect__RQJAr"};